import { ErrorBase } from '@/errors/ErrorBase';

export class LicenseNotExistError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ご利用のライセンスは有効ではないため、ログインすることができません。';
    }

    static get errorName(): string {
        return 'LicenseNotExistError';
    }
}
